<template>
  <div>
    <b-form class="b-layout" @submit.prevent="">
      <div>
        <label>{{ $t('title') }}</label>
        <b-input class="input-pentagro" v-model="title"></b-input>
      </div>
      <b-form-group class="occupation-input-container mt-2" :label="$t('titulo-em-pixels') " label-cols-sm="6">
          <b-input class="occupation-input input-pentagro" type="number" min="0" step="1" v-model="textInPixels" />
        </b-form-group>

      <!-- OPERATIONS -->
      <div class="">
        <label for="select-operation">{{ $t('operacao') }}</label>
        <select class="form-control" id="select-operation" @change="changeOperation()" v-model="operationSelected"> 
            <option value="" selected>{{ $t('escolha-uma-operacao') }}</option>
            <option v-for="(operation, index) in operations"
              :key="index" :value="operation">
                {{operation}}
            </option>
        </select>                      
      </div>
      <!-- /OPERATIONS -->

      <!-- ATRIBUTOS -->
      <div v-if="operationSelected" class="pt-2 node-attr">
        <div v-if="attributeList.length > 1" class="mb-2">
          <label for="select-operation">{{ $t('occupation') }}</label>
          <select class="form-control" id="select-occupation" @change="changeOccupation()" v-model="occupationSelected"> 
              <option value="" selected>{{ $t('escolha-uma-operacao') }}</option>
              <option v-for="(value) in attributeList"
                :key="value.key" :value="value.key">
                  {{value.key}}
              </option>
          </select>   
        </div> 

        <div v-if="operationSelected.includes('RBC')" class="mb-4 mt-2">
          <label for="select-operation">{{ $t('dornas') }}</label>
          <select class="form-control" id="select-occupation" @change="changedDornas()" v-model="dornaSelected"> 
              <option value="" selected>{{ $t('selecione-uma-dorna') }}</option>
              <option v-for="(dorna, index) in dornas"
              :key="index" :value="dorna.equipName">
                {{dorna.equipName}}
            </option>
          </select>   
        </div>  
        
        <div v-if="(attributeList.length == 1 || occupationSelected) && !operationSelected.includes('RBC')">
          <b-form-group class="occupation-input-container" label="$t('ocupacao-minima')" label-cols-sm="6">
          <b-input class="occupation-input input-pentagro" @change="checkOccupationValue(minimumOccupation, 'minimum')" type="number" min="0" v-model="minimumOccupation" />
          </b-form-group>

          <b-form-group class="occupation-input-container" label="$t('ocupacao-maxima')" label-cols-sm="6">
            <b-input class="occupation-input input-pentagro" @change="checkOccupationValue(maximumOccupation, 'maximum')" type="number" min="0" v-model="maximumOccupation" />
          </b-form-group>
          <p class="occupation-value">
            <b>{{ $t('ocupacao') }}</b> {{attributeObject.value | ParseNumber }} % 
          </p>
        </div>

        <div v-if="dornaSelected">
          <b-form-group class="occupation-input-container" label="$t('ocupacao-minima')" label-cols-sm="6">
          <b-input class="occupation-input input-pentagro" @change="checkOccupationValue(minimumOccupation, 'minimum')" type="number" min="0" v-model="minimumOccupation" />
          </b-form-group>

          <b-form-group class="occupation-input-container" label="$t('ocupacao-maxima')" label-cols-sm="6">
            <b-input class="occupation-input input-pentagro" @change="checkOccupationValue(maximumOccupation, 'maximum')" type="number" min="0" v-model="maximumOccupation" />
          </b-form-group>
          <p class="occupation-value">
            <b>{{ $t('ocupacao') }}</b> {{this.dornaValue | ParseNumber }} % 
          </p>
        </div>
      </div>
      <!-- /ATRIBUTOS -->

    </b-form>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering"
import { NumberFormat } from "../../utils/tools"
import { FiltersMixin } from '../../../mixins/filtersMixin';

export default {
  props: {
    node: {
      type: Object,
      default: null
    }
  },

  mixins: [ FiltersMixin ],

  data() {
    return {
      formatNumber: NumberFormat,
      minimumOccupation: this.node.minimumOccupation != "" ? parseFloat(this.node.minimumOccupation.replace(",",".")) : 0,
      maximumOccupation: this.node.maximumOccupation != "" ? parseFloat(this.node.maximumOccupation.replace(",",".")) : 0,
      title: this.node.title,
      operations: SingletonEnginnering.operations,
      dornas: [],
      dornaValue: "",
      attributeList: "",
      operationSelected: "",
      occupationSelected: "",
      dornaSelected: "",
      attributeObject: {},
      attributeDorna: {},
      attributeMap: null,
      textInPixels: this.node.textInPixels
    }
  },

  watch:{
    maximumOccupation(){
      this.node.maximumOccupation = this.maximumOccupation;
    },
    minimumOccupation(){
      this.node.minimumOccupation = this.minimumOccupation;
    },
    textInPixels(){
      this.node.textInPixels = parseInt(this.textInPixels);
    },
    title(){
      this.node.title = this.title;
    },
    operationSelected(){
      this.node.attrs = [this.attributeObject];
    },
    occupationSelected(){
      this.node.attrs = [this.attributeObject];
    },
  },

  methods: {
    changeOperation(){
      if (this.operationSelected.includes('RBC')) {
          let equipsName = SingletonEnginnering.getOperationsEquipments(this.operationSelected);
          let propsByEquipment = SingletonEnginnering.getEquipamentsProperties(this.operationSelected);
          
          let auxEquipment = new Array(); 

          equipsName.forEach((e) => {
            let props = propsByEquipment[e];
            
            Object.keys(props).forEach((p) => {
              if (props[p].caption == "Ocupacao") {
                auxEquipment.push(props[p]);
              }
            });
          });
          
        this.dornas = auxEquipment
      }

      const occupationNames = ['TXUTILIZACAO', 'TAXAOCUPACAO', 'OCUPACAO_CUBA', 'OCUPACAO_DORNA', 'OCUPACAO_TROCADOR', 'OCUPACAO', 'TAXAOCUPACAO', 'SS', 'OCUPACAOTROCADOR'];
      this.attributeList = SingletonEnginnering.getOperationsProperties(this.operationSelected).filter(property => occupationNames.includes(property.key.toUpperCase()));
      this.attributeObject = this.attributeList.length == 1 ? this.attributeList[0] : {};
      this.node.dataType = "Operações"
      this.occupationSelected = "";
      this.dornaSelected = "";
    },

    changeOccupation() {
      this.attributeObject = this.attributeList.find(property => property.key == this.occupationSelected);
    },

    changedDornas() {
      this.dornas.forEach(e => {
        if(e.equipName == this.dornaSelected) {
          this.dornaValue = e.value;
          this.node.attrs = [e];
        }
      });
    },

    loadNode(){
      console.log('Carregando\nthis.node :>> ', this.node);

      if(!this.node.dataType)
        return
      
      this.operationSelected = this.node.data[0].index
      this.changeOperation()
      this.attributeObject = this.node.data[0];
      this.occupationSelected = this.attributeList.length > 1 ? this.node.data[0].key : "";
      if (this.operationSelected.includes('RBC')) {
        setTimeout(() => {
          this.dornaSelected = this.node.data[0].equipName;
          this.dornaValue = this.node.data[0].value;
        },200)
      }
    },

    checkOccupationValue(occupationValue, flag) {

      if (occupationValue < 0) {
        if (flag == 'maximum') {
          this.maximumOccupation = 0;
        } else {
          this.minimumOccupation = 0;
        }
      }
    },

  },
  
  mounted(){
    this.loadNode(); 
  }
}
</script>

<style scoped>
form{
  padding: 10px;
  color: #0009;
}

.occupation-value {
  padding-top: 8px;
}
</style>